module.exports = __webpack_public_path__ + "images/gadget/loading-small.gif";